import { fromJS } from 'immutable';

import { notifyOffline } from './actions';

export const defaultState = fromJS({
  offline: false
});

export default function offline(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case notifyOffline.type:
      return newState.set('offline', action.payload.offline);
    default:
      return newState;
  }
}

export const isOffline = state => state.offline.get('offline');
